import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  AcceptConditionsClientRequest,
  AcceptConditionsClientResponse,
} from '../../../@types/acceptConditions'
import { ENV } from '../../../Environment'
import { api } from '../../../Services/API'
import { useAcceptConditionsStore } from '../../../Stores/useAcceptConditionsStore'
import { useConsentsStore } from '../../../Stores/useConsentsStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const headers = {
  'aip-company': ENV().AcceptConditions.Company,
  'aip-channel': ENV().AcceptConditions.Channel,
}

const request = async (payload: AcceptConditionsClientRequest) => {
  const response = await api.post<AcceptConditionsClientResponse>(
    API_ROUTES.acceptConditions,
    payload,
    { headers },
  )

  return response.data
}

export const useAcceptConditions = () => {
  const { setAcceptConditions } = useAcceptConditionsStore()
  const { setConsents } = useConsentsStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: AcceptConditionsClientRequest) => request(payload),
    onSuccess(data) {
      setAcceptConditions(data)
      const consents = data?.consentList?.[0].legalConsents?.map((item) => {
        return {
          ...item,
          answer: false,
        }
      })
      setConsents(consents || [])
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
